"use client"

import React, { useState, useEffect } from 'react';
import Header from './layout/Header';
import Footer from './layout/Footer';
import HeroSection from './sections/HeroSection';
import ServicesSection from './sections/ServicesSection';
import ClientAreaSection from './sections/ClientAreaSection';
import ContactSection from './sections/ContactSection';
import SupportWidget from './ui/SupportWidget';
import VideoModal from './ui/VideoModal';

const PremiumHomepage = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [showVideo, setShowVideo] = useState(false);
  const [scrollY, setScrollY] = useState(0);
  const [scrollProgress, setScrollProgress] = useState(0);

  // Effect para detectar scroll e calcular progresso
  useEffect(() => {
    // Função para lidar com o scroll
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
      setScrollY(window.scrollY);
      
      // Calcular o progresso do scroll (0 a 1)
      const totalHeight = document.body.scrollHeight - window.innerHeight;
      const progress = totalHeight > 0 ? Math.min(window.scrollY / totalHeight, 1) : 0;
      setScrollProgress(progress);
    };

    // Registrar o listener de scroll
    window.addEventListener('scroll', handleScroll);
    
    // Executar uma vez no carregamento para inicializar
    handleScroll();
    
    // Limpar listener ao desmontar
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen flex flex-col font-sans overflow-x-hidden">
      {/* Header */}
      <Header isScrolled={isScrolled} scrollProgress={scrollProgress} />
      
      {/* Main Content - renderizando todos os componentes diretamente */}
      <main>
        {/* 
          NOTA: Propriedade onShowVideo temporariamente removida
          Quando o vídeo estiver disponível, restaure a prop:
          <HeroSection onShowVideo={() => setShowVideo(true)} scrollY={scrollY} />
        */}
        <HeroSection scrollY={scrollY} />
        <ServicesSection />
        <ClientAreaSection scrollY={scrollY} />
        <ContactSection />
      </main>
      
      {/* Footer */}
      <Footer />
      
      {/* Video Modal - único componente realmente condicional */}
      {showVideo && <VideoModal isOpen={showVideo} onClose={() => setShowVideo(false)} />}
      
      {/* Support Widget */}
      <SupportWidget />
    </div>
  );
};

export default PremiumHomepage;